import { useEffect, useState } from "react";
import { countries } from "../../api/fundsCalculatorApi";
import PassportUploadModal from "./PassportUploadModal";
import { authFetch } from "../../../api";
import ConfimationPopup from "../../../STMPages/components/customPopup/ConfimationPopup";
import GlobalDeleteModal from "../Modal/GlobalDeleteModal";
import { DeleteIcon } from "lucide-react";
import VisaUploadSection from "./VisaUploadSection";

export default function PassportDetailsTab({
  formData,
  setFormData,
  handleInputChange,
  errors = {},
  setEditingPassport,
  handleDelete,
  passportError,
  setPassportError,
  setPassportUploadStatus,
  passportUploadStatus,
  setVisaUploadStatus,
  isEditing,
  setIsEditing,
}) {
  const userId = localStorage.getItem("userId");
  const [country, setCountry] = useState([]);
  const [showUploadModal, setShowUploadModal] = useState(false);
  const [passPortData, setpassPortData] = useState([]);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [deleteIndex, setDeleteIndex] = useState(null);
  const [skipUpload, setSkipUpload] = useState(true);
  const [showPassAddForm, setShowPassAddForm] = useState(false);

  const fetchCountry = async () => {
    try {
      const response = await countries();
      setCountry(response.data.data);
    } catch (err) {
      console.log(err);
    }
  };

  const fetchPassportData = async () => {
    try {
      const response = await authFetch(
        "application/show-passport-details-user",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ user_id: userId }),
        },
      );

      const data = await response.json();

      setpassPortData(data.data || []);
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    fetchCountry();
    fetchPassportData();
  }, []);

  const formatDate = (dateString) => {
    if (!dateString) return "—";
    const date = new Date(dateString);
    return date.toLocaleDateString("en-US", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });
  };

  const getCountryName = (id) => {
    const c = country.find((x) => x.id == id);
    return c ? c.country_name : "—";
  };

  const handleEditClick = (p) => {
    setPassportUploadStatus("skipped");
    const formattedIssueDate = p.date_of_issue?.split("T")[0] || "";
    const formattedExpiryDate = p.expiry_date?.split("T")[0] || "";

    setFormData((prev) => ({
      ...prev,
      hasPassport: "yes",
      passportNumber: p.passport_number,
      citizenOf: p.citizen_of,
      countryOfIssue: p.country_of_issue,
      placeOfIssue: p.place_of_issue,
      dateOfIssue: formattedIssueDate,
      expiryDate: formattedExpiryDate,
      countryOfResidence: p.country_of_residence,
      passportFile: p.passport_doc || null,
    }));

    setIsEditing(true);
    setShowPassAddForm(false);
    setEditingPassport(p);
  };

  return (
    <div className="space-y-4">
      {showDeleteModal && (
        <ConfimationPopup
          handleClose={() => setShowDeleteModal(false)}
          open={showDeleteModal}
          component={
            <GlobalDeleteModal
              text="Delete Details ?"
              subText="Are you sure you want to delete your Passport Details?"
              buttonTitle="Delete"
              startIcon={<DeleteIcon />}
              open={showDeleteModal}
              onClose={() => {
                setShowDeleteModal(false);
              }}
              onConfirm={() => {
                handleDelete(deleteIndex);
                setShowDeleteModal(false);
              }}
            />
          }
        />
      )}

      {/* Heading */}
      <div className="flex justify-between">
        <div className="text-md font-altisunisa text-black flex items-center gap-2 mb-2">
          <img className="h-8 w-8" src="/PdHeading.png" alt="PD" />
          Passport Details
        </div>

        {passPortData.length === 0 && (
          <button
            onClick={() => {
              if (skipUpload) {
                // Skip upload
                setPassportUploadStatus("skipped");
              } else {
                // Go back to upload
                setPassportUploadStatus("pending");
              }
              setSkipUpload((prev) => !prev);
            }}
            className="px-4 py-2 bg-white text-[#572575] border border-[#572575] rounded-lg text-sm font-semibold"
          >
            {skipUpload ? "Skip Upload" : "Upload Passport"}
          </button>
        )}
      </div>

      {/* Upload Modal */}
      <PassportUploadModal
        open={showUploadModal}
        onClose={() => setShowUploadModal(false)}
        onUpload={(file) => {
          setFormData({ ...formData, passportFile: file });
          setShowUploadModal(false);
        }}
      />
      {(passPortData.length === 0 || isEditing) && (
        <div>
          {/* Do you have passport? */}
          <label className="block mb-2 font-medium text-black font-semibold">
            Do you have a Passport? <span className="text-red-500">*</span>
          </label>

          <div className="flex gap-6 items-center p-2">
            <label className="flex items-center gap-2">
              <input
                type="radio"
                name="hasPassport"
                value="yes"
                checked={formData.hasPassport === "yes"}
                onChange={handleInputChange}
              />
              Yes
            </label>

            <label className="flex items-center gap-2">
              <input
                type="radio"
                name="hasPassport"
                value="no"
                checked={formData.hasPassport === "no"}
                onChange={handleInputChange}
              />
              No
            </label>
          </div>

          {errors.hasPassport && (
            <p className="text-red-500 text-sm">{errors.hasPassport}</p>
          )}

          {/* No Passport → Tentative Dates */}
          {formData.hasPassport === "no" && (
            <>
              <div className="mb-4">
                <label className="font-medium text-black font-semibold mb-2 block">
                  Select your tentative date for applying{" "}
                  <span className="text-red-500">*</span>
                </label>

                <input
                  type="date"
                  name="tentativeDate"
                  value={formData.tentativeDate || ""}
                  onChange={handleInputChange}
                  className="w-full border rounded-md px-3 py-2 mt-2 focus:ring-2 focus:ring-purple-500"
                />
              </div>
              {passportError && !formData.tentativeDate && (
                <div className="mt-4 border border-red-500 bg-red-50 text-red-600 p-4 rounded-lg flex items-center text-center gap-2 text-md leading-[20px] font-medium font-inter">
                  <span className="font-semibold">!</span>
                  <span>{passportError}</span>
                </div>
              )}
            </>
          )}

          {/* Passport Form (YES) */}
          {formData.hasPassport === "yes" &&
            passportUploadStatus !== "pending" && (
              <div className="grid grid-cols-2 gap-6 bg-white p-4 border rounded-xl">
                {/* Upload Passport */}
                {/* <Field
                  label="Upload Passport"
                  required
                  error={errors.passportFile}
                  children={
                    <input
                      onClick={() => setShowUploadModal(true)}
                      type="text"
                      placeholder="Upload Your Document"
                      readOnly
                      className="border w-full p-2 rounded-lg cursor-pointer"
                    />
                  }
                /> */}

                {/* Passport Number */}
                <Field
                  label="Passport Number"
                  required
                  error={errors.passportNumber}
                >
                  <input
                    type="text"
                    placeholder="Enter Passport Number"
                    name="passportNumber"
                    value={formData.passportNumber}
                    onChange={handleInputChange}
                    className="border w-full p-2 rounded-lg"
                  />
                </Field>

                {/* Citizenship */}
                <Field label="Citizens of" required error={errors.citizenOf}>
                  <select
                    name="citizenOf"
                    value={formData.citizenOf}
                    onChange={handleInputChange}
                    className="border w-full p-2 rounded-lg"
                  >
                    <option value="">Select Country</option>
                    {country?.map((item) => (
                      <option key={item.id} value={item.id}>
                        {item.country_name}
                      </option>
                    ))}
                  </select>
                </Field>

                {/* Country of Issue */}
                <Field
                  label="Country of Issue"
                  required
                  error={errors.countryOfIssue}
                >
                  <select
                    name="countryOfIssue"
                    value={formData.countryOfIssue}
                    onChange={handleInputChange}
                    className="border w-full p-2 rounded-lg"
                  >
                    <option value="">Select Country</option>
                    {country?.map((item) => (
                      <option key={item.id} value={item.id}>
                        {item.country_name}
                      </option>
                    ))}
                  </select>
                </Field>

                {/* Place of Issue */}
                <Field
                  label="Place of Issue"
                  required
                  error={errors.placeOfIssue}
                >
                  <input
                    type="text"
                    name="placeOfIssue"
                    placeholder="Enter Place Of Issue"
                    value={formData.placeOfIssue}
                    onChange={handleInputChange}
                    className="border w-full p-2 rounded-lg"
                  />
                </Field>

                {/* Date of Issue */}
                <Field
                  label="Date of Issue"
                  required
                  error={errors.dateOfIssue}
                >
                  <input
                    type="date"
                    name="dateOfIssue"
                    value={formData.dateOfIssue}
                    onChange={handleInputChange}
                    className="border w-full p-2 rounded-lg"
                  />
                </Field>

                {/* Expiry Date */}
                <Field label="Expiry Date" required error={errors.expiryDate}>
                  <input
                    type="date"
                    name="expiryDate"
                    value={formData.expiryDate}
                    onChange={handleInputChange}
                    className="border w-full p-2 rounded-lg"
                  />
                </Field>

                {/* Country of Residence */}
                <Field
                  label="Country of Residence"
                  required
                  error={errors.countryOfResidence}
                >
                  <select
                    name="countryOfResidence"
                    value={formData.countryOfResidence}
                    onChange={handleInputChange}
                    className="border w-full p-2 rounded-lg"
                  >
                    <option value="">Select Country</option>
                    {country?.map((item) => (
                      <option key={item.id} value={item.id}>
                        {item.country_name}
                      </option>
                    ))}
                  </select>
                </Field>
              </div>
            )}
        </div>
      )}
      {/* UPLOAD */}
      {formData.hasPassport === "yes" &&
        passportUploadStatus === "pending" &&
        passPortData.length === 0 && <VisaUploadSection />}
      {/* Show Existing Passport Data */}
      {passPortData.length > 0 && !isEditing && (
        <div className="space-y-4 mb-6">
          {passPortData.map((p, index) => (
            <div
              key={index}
              className="bg-[#FFF6FB] border border-[#F3D9EA] rounded-xl p-6 shadow-sm"
            >
              {/* Top Area */}
              <div className="flex justify-between items-center mb-4">
                <h2 className="text-lg font-semibold text-black">
                  Passport Number: {p.passport_number}
                </h2>

                <div className="flex gap-4 text-sm">
                  <button
                    onClick={() => handleEditClick(p)}
                    className="text-[#177BE5] text-sm font-semibold hover:underline"
                  >
                    ✎ Edit
                  </button>
                  <button
                    onClick={() => {
                      setDeleteIndex(index);
                      setShowDeleteModal(true);
                    }}
                    className="text-[#D20000] text-sm font-semibold hover:underline"
                  >
                    🗑 Delete
                  </button>
                </div>
              </div>

              {/* Details Grid */}
              <div className="grid grid-cols-2 gap-4">
                <Detail label="Citizenship" value={p.citizen_of} />
                <Detail
                  label="Country of Issue"
                  value={getCountryName(p.country_of_issue)}
                />
                <Detail label="Place of Issue" value={p.place_of_issue} />
                <Detail
                  label="Country of Residence"
                  value={getCountryName(p.country_of_residence)}
                />
                <Detail
                  label="Date of Issue"
                  value={formatDate(p.date_of_issue)}
                />
                <Detail label="Expiry Date" value={formatDate(p.expiry_date)} />
                <Detail
                  label="Passport Document"
                  value={p.passport_doc ? "Uploaded" : "Not uploaded"}
                />
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

/* Reusable Components */
const Detail = ({ label, value }) => (
  <div>
    <p className="text-sm text-gray-600 mb-1">{label}</p>
    <div className="h-10 bg-white border rounded-md px-3 flex items-center font-medium font-semibold text-black ">
      {value || "—"}
    </div>
  </div>
);

const Field = ({ label, required, error, children }) => (
  <div>
    <label className="block mb-1 text-black font-medium">
      {label} {required && <span className="text-red-500">*</span>}
    </label>
    {children}
    {error && <p className="text-red-500 text-sm">{error}</p>}
  </div>
);
